// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"group-checkboxes-control-component_rootContainer__9t2z0","checkboxItem":"group-checkboxes-control-component_checkboxItem__3DumU"};